import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter, NavLink } from 'react-router-dom'
import  Header from '../Header'
import SideMenu from '../SideMenu'
import { Loading } from '../'
import InfoModal from '../SharedModal/InfoModal'
import ConfirmModal from 'components/SharedModal/ConfirmModal'
import { LayoutContainer, MainContainer, BodyContainer }  from './styled'
import { Sidebar, Segment, Menu } from 'semantic-ui-react'
import { setShowMobileMenu } from 'ducks/app'

const Layout = (props) => {
  const { children, showMenu, collapseMenu, history, showMobileMenu, setShowMobileMenu, menus } = props
  return (
    <LayoutContainer>
      <Header history={history} />
      <Sidebar.Pushable as={Segment} style={{ padding: '0px', margin: '0px', border: 'none', borderRadius: '0px' }}>
        <Sidebar
          as={Menu}
          animation='overlay'
          icon='labeled'
          inverted
          onHide={() => setShowMobileMenu(false)}
          vertical
          visible={showMobileMenu}
          width='thin'
        >
          {
            menus.map(m => 
              {
                if (m.subMenus && m.subMenus.length) {
                  return m.subMenus.map(s => 
                    <Menu.Item as='a'>
                      <NavLink
                        onClick={() => setShowMobileMenu(false)}
                        to={s.path}
                      >
                        {s.name}
                      </NavLink>
                    </Menu.Item>
                  )
                } else {
                  return (
                    <Menu.Item as='a'>
                      <NavLink
                        onClick={() => setShowMobileMenu(false)}
                        to={m.path}
                      >
                        {m.name}
                      </NavLink>
                    </Menu.Item>
                  )
                }
              }
            )
          }
        </Sidebar>

        <Sidebar.Pusher dimmed={showMobileMenu} style={{ padding: '0px', margin: '0px' }}>
          <Segment basic style={{ padding: '0px', margin: '0px' }}>
          <MainContainer>
            <SideMenu />
            <BodyContainer showMenu={showMenu} collapseMenu={collapseMenu}>
              {children}
            </BodyContainer>
          </MainContainer>
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
      <Loading />
      <InfoModal />
      <ConfirmModal />
    </LayoutContainer>
  )
}

const mapStateToProps = (state) => ({
  showMenu: state.app.showSideMenu,
  collapseMenu: state.app.collapseSideMenu,
  showMobileMenu: state.app.showMobileMenu,
  menus: state.app.menus
})

const mapDispatchToProps = {
  setShowMobileMenu
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connect((state, props) => ({
    history: props.history,
    children: props.children
  }))
)

export default withRouter(enhance(Layout))